export default {
  setRedirectURL(state, payload) {
    state.redirectURL = payload
  }
}
